import React from 'react';

import css from './Card.module.scss';

const Card = ({ src, alt, heading, description, link }) => {
	return (
		<div className={css.card}>
			<img src={src} alt={alt} />
			<h4>{heading}</h4>
			<span>{description}</span>
			<a
				href={link}
				target="_blank"
				rel="noopener noreferrer"
				className="linkArrow"
			>
				Learn more
			</a>
		</div>
	);
};

export default Card;
